
/* globals

ActiveXObject,

*/

export {
	e,
	ipx,
	pxi,
	httpPost,
	get_cookie,
	set_cookie,
	cap_first,
	secs_to_hms,
	hms_to_secs,
	jersify
};

import {state} from './index.js';

// ------------------------------
// Utilities
// ------------------------------

function e(x) {
	return document.getElementById(x);
}

function ipx(i) {
	return i + "px";
}

function pxi(px) {
	return parseInt(px.replace("px", ""));
}

function httpPost(url, params, f) {
	var x;
	if (window.XMLHttpRequest) {
		x = new XMLHttpRequest();
	} else if (window.ActiveXObject) {
		x = new ActiveXObject("Microsoft.XMLHTTP");
	} else {
		return;
	}

	x.onreadystatechange = function() {
		if (x.readyState == 4) {
			if (f != undefined) {
				f(x.responseText);
			}
		}
	};

	x.open("POST", url, true);
	x.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	x.send(params);
}

function get_cookie(key) {
	if (document.cookie.length > 0) {
		var p1 = document.cookie.indexOf(key + "=");
		var p2 = 0;

		if (p1 >= 0) {
			p1 = p1 + key.length + 1;
			p2 = document.cookie.indexOf(";", p1);

			if (p2 == -1) {
				p2 = document.cookie.length;
			}

			return decodeURIComponent(document.cookie.substring(p1, p2));
		}
	}

	return "";
}

function set_cookie(key, val, days, dompath) {
	var expdays = (days != undefined) ? days : 365 * 100;
	var expdate = new Date();
	var path    = (dompath != undefined) ? dompath : "/";
	expdate.setDate(expdate.getDate() + expdays);
	document.cookie = key + "=" + encodeURIComponent(val) + ";expires=" + expdate.toGMTString() + ";path=" + path;
}

function cap_first(s) {
	if (typeof(s) !== 'string'){
		return s;
	}
	return s ? s[0].toUpperCase() + s.substring(1).toLowerCase() : null;
}

function secs_to_hms(secs) {
	var hours   = Math.floor(secs/3600);
	var minutes = Math.floor((secs - (hours * 3600)) / 60);
	var seconds = secs - (hours * 3600) - (minutes * 60);

	return (hours > 0) ? hours + ":" + ( (minutes > 0) ? ((minutes > 9) ? minutes : "0" + minutes) : "00" ) + ":" + ( (seconds > 0) ? ((seconds > 9) ? seconds : "0" + seconds) : "00" ) : minutes + ":" + ( (seconds > 0) ? ((seconds > 9) ? seconds : "0" + seconds) : "00" );
}

function hms_to_secs(hms) {
	// hms should be string in the format "h:m:s" or "m:s" where h,m,s are integers
	var secs = 0,
	    time_array = hms.split(':');
	if (time_array.length === 3){
		secs += parseInt(time_array[2]);
		secs += (parseInt(time_array[1]) * 60);
		secs += (parseInt(time_array[0]) * 3600);
	} else {
		secs += parseInt(time_array[1]);
		secs += (parseInt(time_array[0]) * 60);
	}
	return (secs);
}

function get_current_team() {
	// returns team object for current selection
	if (state.teams && e("selTeam") && e("selTeam").value){
		for (var i=0; i < state.teams.length; i++){
			if (state.teams[i].id === +e("selTeam").value){
				return state.teams[i];
			}
		}
	}
}

function jersify(playernum) {
	// Takes a playernum and converts it to jerseynum, if defined
	var team = get_current_team();
	for (var i=0; i < team.players.length; i++){
		if (team.players[i].num === playernum){
			if (team.players[i].jersey !== undefined){
				return team.players[i].jersey;
			} else {
				return team.players[i].num;
			}
		}
	}
	return playernum;
}
